export const environment = {
  production: false,
  // serverIP: 'https://munsalik-batch-api.lfdanalytics.com/',
  serverIP: 'https://batchscreening-api.lfdanalytics.com/',
};
